module.exports = __webpack_public_path__ + "assets/img/title-987ff5b3.png";